export const LOCALES = {
    RUSSIAN: 'ru-RU'
}